import React from 'react';
import {Box, Grid, TextFieldForm, Typography} from 'web-library';


import { makeStyles } from 'tss-react/mui';
import { UseFormReturn} from "react-hook-form";

const useStyles = makeStyles()((theme) =>
({
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
}));

export enum ControlType {
  'text' = 'text',
  'number' = 'number',
  'date' = 'date',
}

interface ConfigItemProps {
  label: string;
  description: string;
  type?: ControlType;
  defaultValue: any;
  disabled?: boolean;
  name: string;
  ariaLabel?: string;
  hidden?: boolean;
  form?: UseFormReturn<any>;
  rules?: any;
  isError?: boolean;
}

export const ConfigItem = (
  (
    {
      label,
      description,
      type,
      defaultValue,
      form,
      rules,
      isError,
      disabled = false,
      name,
      ariaLabel,
      hidden = false,
    }: ConfigItemProps,
  ) => {
    const { classes } = useStyles();
    const inputControl = () => {
    switch (type) {
      case ControlType.text:
        return (
            <TextFieldForm
                form={form}
                rules={rules}
                error={isError}
                style={hidden ? { display: 'none' } : {}}
                type={hidden ? 'hidden' : 'text'}
                name={name}
                defaultValue={defaultValue}
            />
        );
      case ControlType.number:
        return (
            <TextFieldForm
                form={form}
                rules={rules}
                error={isError}
                style={hidden ? { display: 'none' } : {}}
                type={hidden ? 'hidden' : 'number'}
                name={name}
                defaultValue={defaultValue}
            />
          );
        default:
          return null;
      }
    };
    return hidden ? (
        inputControl()
    ) : (
      <Box className={classes.container}>
        <Grid container>
          <Grid xs={10}>
            <Typography variant="h6">{label}</Typography>
            <Typography variant="body2">{description}</Typography>
          </Grid>
          <Grid xs={2}>
            {disabled || !type ? (
              <Typography variant="body2">{defaultValue}</Typography>
            ) : (
                inputControl()
            )}
          </Grid>
        </Grid>
      </Box>
    );
  }
);
